import { each, selectAll, siblings } from '../shared/utils/dom';
import { userPreferenceApi } from './api';

const makeQuickTipClickable = function (element, linkUrl, linkTarget) {
  element.addEventListener('click', (event) => {
    event.preventDefault();
    if (!event.target.classList.contains("preferenceControl")) {
      window.open(linkUrl, linkTarget);
    }
  });

  each(element.children, (child) => {
    if (child.nodeName !== "BUTTON") {
      makeQuickTipClickable(child, linkUrl, linkTarget);
    }
  });
}

const quickTipInit = function () {
  each(selectAll(".tip__clickable"), (quickTipDiv) => {
    const linkUrl = quickTipDiv.dataset["linkUrl"];
    const linkTarget = quickTipDiv.dataset["linkTarget"];
    makeQuickTipClickable(quickTipDiv, linkUrl, linkTarget);
  });
  each(selectAll(".preferenceControl"), (preferenceControl) => {
    preferenceControl.addEventListener('click', (event) => {
      const button = event.srcElement;
      const dataSet = button.dataset;
      const typeId = dataSet["typeId"];
      let preferenceChoice = dataSet["preferenceChoice"];
      if (preferenceChoice === "SHOW") {
        preferenceChoice = "HIDE"
        button.innerText = "Learn More";
      } else {
        preferenceChoice = "SHOW"
        button.innerText = "Hide";
      }
      dataSet["preferenceChoice"] = preferenceChoice;
      each(siblings(button), (sibling) => {
        if (sibling.nodeName === "P") {
          if (sibling.classList.contains("hidden")) {
            sibling.classList.remove("hidden");
          } else {
            sibling.classList.add("hidden");
          }
        }
      });
      userPreferenceApi.storeUserPreference("QUICK_TIP", typeId, preferenceChoice);
    });
  });
}

export default function quickTip() {
  quickTipInit();
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/quickTip.js